import { Phone } from "lucide-react";
import { useLocation } from "react-router-dom";
import { SP_WIDGET_ATTRS } from "./BookingButton";
import { BOOKING_URL, PHONE_TEL } from "@/data/content";

/**
 * Sticky bottom action bar — only visible on mobile, hidden on /admin.
 * Two big thumb-friendly CTAs: Call and Book.
 */
export default function MobileBookBar() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;

  return (
    <div
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 border-t backdrop-blur-md flex"
      style={{
        background: "rgba(249,246,240,0.94)",
        borderColor: "var(--sano-border)",
        paddingBottom: "env(safe-area-inset-bottom)",
      }}
      data-testid="mobile-book-bar"
    >
      <a
        href={PHONE_TEL}
        className="flex-1 flex items-center justify-center gap-2 py-4 text-sm font-medium border-r"
        style={{ borderColor: "var(--sano-border)", color: "var(--sano-ink)" }}
        data-testid="mobile-call-btn"
      >
        <Phone size={16} strokeWidth={1.5} /> Call
      </a>
      <a
        href={BOOKING_URL}
        target="_blank"
        rel="noreferrer"
        {...SP_WIDGET_ATTRS}
        className="flex-1 flex items-center justify-center gap-2 py-4 text-sm font-semibold"
        style={{ background: "var(--sano-olive)", color: "var(--sano-bg)" }}
        data-testid="mobile-book-btn"
      >
        Book Now
      </a>
    </div>
  );
}
